import React from 'react';
import SectionHeader from './SectionHeader';
import PandiVideo from './PandiVideo';
import { REEL } from '../mock';

export default function Reel() {
  return (
    <section className="section-pad">
      <div className="container-narrow">
        <SectionHeader chapter={REEL.chapter} label={REEL.label} heading={REEL.heading} />

        <div className="grid lg:grid-cols-12 gap-8 mb-10 items-start">
          <div className="lg:col-span-8">
            <p className="font-serif text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/85">{REEL.body}</p>
          </div>
          <div className="lg:col-span-4">
            <div className="flex flex-wrap items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
              <span className="font-sc text-[10px] gold-text tracking-[0.4em]">{REEL.meta}</span>
              <span className="font-sc text-[10px] text-[color:var(--bx-muted)] tracking-[0.4em]">{REEL.yearTag}</span>
            </div>
          </div>
        </div>

        {/* Full-width 21:9 HD video */}
        <div className="w-full">
          <PandiVideo />
        </div>
      </div>
    </section>
  );
}
